// extracted by mini-css-extract-plugin
export default {"caption":"ohzbBlRGCi34tWjM2emA"};